/*
 * 文件EN: APIMonitor.js,
 * 文件CN: api监控,
 * 创建时间: Wednesday, 17th June 2020 9:50:58 am,
 * 创建人: yeungxsheng,
 * 联系邮箱: 854427332@qq.com,
 */

import request from '@/plugins/http'

/**
 * @desc 列表获取
 * @method GET
 * @param {参数说明 详细见 swagger}
 */
export const getListData = params => {
  return request.get('/apiManager/api/monitorList', params)
}

/**
 * @desc api 发送请求(返回的是第三方api的json数据)
 * @method POST
 * @param {参数说明 详细见 swagger}
 */
export const sendRequest = params => {
  return request.post('/apiManager/api/sendRequest', params, { json: true })
}
